import { Spinner } from "component-library";

import "./FullPageSpinner.scss";

export const FullPageSpinner = () => {
  return (
    <div className="c-full-page-spinner__container">
      <div className="c-full-page-spinner__spinner">
        <Spinner />
      </div>
    </div>
  );
};
